import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import React, { useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { v2theme } from "../../../styles/Theme";
import { ReactComponent as IconFilter } from "../../../assets/Icon-Filter.svg";
import { FilterModal } from "./FilterModal";
import { DbUser } from "../../../interfaces";

const useStyle = makeStyles((theme) => ({
  filterButton: {
    backgroundColor: "transparent",
    borderRadius: "8px",
    color: theme.palette.text.secondary,
    width: "93px",
    height: "40px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      width: "93px",
      height: "40px",
      color: theme.palette.text.primary,
      transition: "all 0.5 ease-in-out",
      boxShadow: "none",
    },
  },
  filterButtonActive: {
    backgroundColor: "#F2F2F2",
    width: "93px",
    height: "40px",
    color: theme.palette.text.primary,
    transform: "none",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      width: "93px",
      height: "40px",
      color: theme.palette.text.primary,
      transform: "none",
    },
  },
  selectedFilterButton: {
    color: theme.palette.text.primary,
    borderRadius: "15px",
    "&:hover": {
      border: `2px solid ${v2theme.palette.primary.main}`,
      transform: "none",
    },
  },
  filterButtonIcon: {
    width: "16px",
    height: "16px",
  },
}));

interface FilterProps {
  currentUser: DbUser;
  activeFilters: { [key: string]: [] };
  setActiveFilters: (activeFilters: { [key: string]: [] }) => void;
  currentTab: number;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const FilterButton = (props: FilterProps) => {
  const classes = useStyle();
  const { activeFilters, currentTab, setActiveFilters, onClick } = props;
  const [openFilterModal, setOpenFilterModal] = React.useState(false);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick(event);
    setOpenFilterModal(true);
  };
  const handleClose = () => {
    setOpenFilterModal(false);
  };
  useEffect(() => {
    handleClose();
  }, [activeFilters]);
  // count length of items in activeFilters
  Object.entries(activeFilters).reduce((acc, curr) => {
    return acc + curr[1].length;
  }, 0);
  return (
    <>
      <Box sx={{ position: "relative", marginRight: "auto", marginLeft: "16px" }}>
        <Button
          onClick={handleClick}
          size="medium"
          className={
            Object.entries(activeFilters).reduce((acc, curr) => {
              return acc + curr[1].length;
            }, 0) > 0
              ? classes.filterButtonActive
              : classes.filterButton
          }
          variant="contained"
          endIcon={
            Object.entries(activeFilters).reduce((acc, curr) => {
              return acc + curr[1].length;
            }, 0) > 0 ? (
              <Box
                sx={{ borderRadius: "50%", backgroundColor: "#000000" }}
                className={classes.filterButtonIcon}>
                <Typography
                  sx={{
                    color: "#ffffff",
                    fontSize: "0.6em",
                    fontWeight: "600",
                  }}>
                  {Object.entries(activeFilters).reduce((acc, curr) => {
                    return acc + curr[1].length;
                  }, 0)}
                </Typography>
              </Box>
            ) : (
              <IconFilter className={classes.filterButtonIcon} />
            )
          }>
          Filter
        </Button>
      </Box>
      <FilterModal
        currentUser={props.currentUser}
        activeFilters={activeFilters}
        applyFilter={(data) => {
          setActiveFilters(data);
        }}
        currentTab={currentTab}
        handleClose={handleClose}
        open={openFilterModal}
      />
    </>
  );
};
